module.exports = __webpack_public_path__ + "images/ccd5031e48c34a76e747f4f1cd91bd44.png";